<!-- eslint-disable @typescript-eslint/no-explicit-any -->
<script setup lang="ts">
import { computed, toRefs } from "vue";
import type { SafeParseReturnType } from "zod";
import { get } from "lodash-es";

const props = defineProps<{
  result?: SafeParseReturnType<Record<string, any>, Record<string, any>>;
  field: string;
}>();
const { result, field } = toRefs(props);

const formattedError = computed(() => {
  const r = result?.value;
  if (!r?.success) {
    return r?.error.format();
  }

  return undefined;
});

const formattedErrorForField = computed(() =>
  get(formattedError?.value, field.value),
);

const errors = computed(() => formattedErrorForField.value?._errors);
const inputClass = computed(() => {
  const validated = formattedError?.value !== undefined;
  const error = Boolean(formattedErrorForField.value);

  return {
    "is-success": validated && !error,
    "is-danger": validated && error,
  };
});
</script>

<template>
  <slot v-bind="{ inputClass }"></slot>

  <slot name="validation-messages">
    <p v-for="(error, index) in errors" :key="index" class="help is-danger">
      {{ error }}
    </p>
  </slot>
</template>
